import { PricingMatrixEditor } from './PricingMatrixEditor';

export { PricingMatrixEditorForUsed } from './PricingMatrixEditorForUsed';

export default PricingMatrixEditor;
